import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { ExtensionsService } from '../../_services/extensions.service';
import { Extension } from '../../_types/extension';
import { User } from 'src/app/modules/users/_types/user';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { LocalStorageService } from 'angular-web-storage';
import { environment } from 'src/environment/environment';
import { DDIsService } from 'src/app/modules/users/_services/ddis.service';
import { DDI } from 'src/app/modules/users/_types/ddi';
import { RecordingService } from 'src/app/modules/phone/_services/recording.service';
import { Recording } from 'src/app/modules/phone/_types/recording';

@Component({
    selector: 'app-recording-detail',
    templateUrl: './recording-detail.component.html',
    styleUrls: ['./recording-detail.component.css'],
    standalone: false
})
export class RecordingDetailComponent implements OnInit {

  public recording: Recording | null = null;
  public transcriptionText: string = '';
  public transcriptionSegments: any[] = [];

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private recordingService: RecordingService
  ) { 
    
  }

  ngOnInit() {
    let id = this.config.data.id;
    if(id){
      this.loadData(id);
    }
  }

  async loadData(id: string){
    let recording = await firstValueFrom(this.recordingService.get(id));
    this.recording = recording;

    //preparamos los segmentos de transcripcion para mostrarlos en la vista
    if(this.recording.transcription){
      let transcription = JSON.parse(this.recording.transcription);
      this.transcriptionText = transcription.text;
      if(transcription.segments){
        this.transcriptionSegments = transcription.segments;
      }
    }
  }

  getRecordingUrl():string {
    if(!this.recording) {
      return '';
    }
    let url = this.recordingService.getDownloadUrl(this.recording);
    return url;
  }

}
